import axios from "axios"
import {countriesDataModel} from './stateCountry/countriesDataModel'

export const countryIsGuestModel = {
  mutations: {
    /**
     * @param state
     * @param {Object} payload
     */
    fillData(state, payload) {
      state.countriesData.showModal = payload.data.show
      state.countriesData.countryIpId = parseInt(payload.data.countryIpId)
      state.countriesData.countryIpName = payload.data.countryIpName
    },
    /**
     * @param state
     */
    hiddenShowModel(state) {
      state.countriesData.showModal = false
    },
  },

  actions: {
    /** заполняем полученными данными */
    getCountryIsGuest({commit}) {
      axios.get('/base-vue/get-country-is-guest')
        .then(res => {
          if (res.data.status === 'ok') {
            commit('fillData', res)
          }
        })
    },
    /** заглушка для закрытия модалки, если гость отметит (да/нет) */
    hiddenModalNotification() {
      axios.get('/base-vue/hidden-modal-notification')
        .then(res => {
          console.log(res)
        })
    },
  },
  modules: {
    countriesData: countriesDataModel
  },
  namespaced: true
}